:host {
  max-width: 100%;
  display: flex;
  flex-direction: column;

  ::part(item-group-icons) {
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    white-space: normal;
    padding-bottom: 0 !important;
  }

  ::part(grid-cell-icon) {
    height: 100%;
    display: inline-flex;
    align-items: center;
  }
}

.page__header {
  padding: calc(2 * var(--spacer)) calc(3 * var(--spacer));
  border-bottom: 1px solid var(--grey-layout-chart-100);
}

.push-body {
  &--menu {
    display: none;
  }
}

.push-body,
.push-body--content {
  height: 100%;
}

.wrapper {
  flex-direction: column;
  height: 100%;
}

.header {
  display: flex;
  flex-direction: column;
  height: 64px;
  padding: calc(var(--spacer) * 2) calc(var(--spacer) * 2.5) calc(var(--spacer) * 3) calc(var(--spacer) * 2.5);

  &--top {
    display: flex;
    justify-content: space-between;
  }
}

.title {
  color: var(--body-text-arrows-400);
}

.content {
  flex-grow: 2;
  height: 100%;

  .grid {
    height: 100%;
  }

  gz-grid-view {
    align-items: stretch;
    min-height: 100%;
  }
}

gz-push-body-layout[resizable][isopen]::part(header) {
  margin-bottom: calc(2 * var(--spacer));
  padding: 0 calc(var(--spacer) * 2) 0 calc(var(--spacer) * 2);
  text-transform: uppercase;
}

gz-push-body-layout[resizable][isopen]::part(sideNav) {
  min-width: 240px;
}

gz-button + gz-button {
  margin-left: calc(var(--spacer) * 2);
}

#no-results {
  height: 100%;

  #no-results-scan-config-button {
    margin-top: calc(3 * var(--spacer));
  }

  #no-results-message-description {
    margin-top: calc(var(--spacer) * 2);
    font-size: var(--body-size);
  }
}
